import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import styles from '../../styles/AppStyles';
import CheckBox from './Checkbox';
import { TemplateFile } from '../types/LandingPageTypes';
import { useFeatureFlag } from '../featureFlags/FeatureFlagsContext';

interface LandingPageGenerationProps {
  progress: number;
  progressStatus: string;
  skipImageGeneration: boolean;
  setSkipImageGeneration: (val: boolean) => void;
  skipWidgets: boolean;
  setSkipWidgets: (val: boolean) => void;
  publishToWordPress: boolean;
  setPublishToWordPress: (val: boolean) => void;
  wordPressConfigured: boolean;
  handleOpenConfig: () => void;
  handleGenerate: () => void;
  handleCancel: () => void;
  loading: boolean;
  isPreviewPaneActive: boolean;
  templateFile: TemplateFile | null;
  productDescription: string;
  fromScratchMode: boolean;
}

const LandingPageGeneration: React.FC<LandingPageGenerationProps> = ({
  progress,
  progressStatus,
  skipImageGeneration,
  setSkipImageGeneration,
  skipWidgets,
  setSkipWidgets,
  publishToWordPress,
  setPublishToWordPress,
  wordPressConfigured,
  handleOpenConfig,
  handleGenerate,
  handleCancel,
  loading,
  isPreviewPaneActive,
  templateFile,
  productDescription,
  fromScratchMode,
}) => {
  const extraCreditPurchaseEnabled = useFeatureFlag('extraCreditPurchaseEnabled');
  // Generate button should only be enabled when:
  // 1. A template JSON file is selected OR scratch mode is enabled
  // 2. Product description has text
  // 3. Not currently loading
  // 4. Preview pane is active
  const hasTemplate = fromScratchMode || templateFile !== null;
  const isGenerateEnabled = !loading && isPreviewPaneActive && hasTemplate && productDescription.trim().length > 0;
  return (
    <View style={styles.sectionWrapper}>
      {/* Progress bar */}
      <View style={styles.progressBarContainer}>
        {/* <View style={[styles.progressBar, { width: `${progress}%` }]} >
          <Text>{progress}%</Text>
        </View> */}
          <View style={[styles.progressBar, { width: `${progress}%` }]} >
          {progress > 0 && (
            <Text style={styles.progressText}>{progress}%</Text>
          )}
        </View>
        {progress === 0 && (
          <Text style={styles.progressText}>0%</Text>
        )}
        
      </View>
      <Text style={styles.progressStatusText}>{progressStatus || 'Ready'}</Text>

      <View style={styles.checkboxGroup}>
        <CheckBox
          label="Skip Image Generation"
          checked={skipImageGeneration}
          onChange={setSkipImageGeneration}
        />
        <CheckBox
          label="Skip The Generation Of HTML Widgets"
          checked={skipWidgets}
          onChange={setSkipWidgets}
        />
        <CheckBox
          label={wordPressConfigured ? 'Publish to WordPress' : 'Publish to WordPress (not configured)'}
          checked={publishToWordPress}
          onChange={wordPressConfigured ? setPublishToWordPress : () => undefined}
        />
      </View>

      {/* Action buttons inline until wrap */}
      <View style={[styles.actionRow]}> 
        <TouchableOpacity
          style={[styles.configButton, { marginRight: 12, marginBottom: 8 }]}
          onPress={handleOpenConfig}
        >
          <Text style={styles.gearIcon}>⚙️</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.button,
            styles.primaryButton,
            { flex: -1, marginRight: 12, marginBottom: 8 },
            !isGenerateEnabled && { opacity: 0.5 }
          ]}
          onPress={handleGenerate}
          disabled={!isGenerateEnabled}
        >
          <Text style={styles.primaryButtonText}>
            {fromScratchMode ? 'Create Template and Generate' : 'Generate'}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.button, styles.secondaryButton, { flex: 0, marginBottom: 8 }]}
          onPress={handleCancel}
          disabled={!loading}
        >
          <Text style={styles.secondaryButtonText}>Cancel</Text>
        </TouchableOpacity>
      </View>
      {extraCreditPurchaseEnabled && (
        <Text style={[styles.mediaTranslatorCostHint, { marginBottom: 4 }]}>
          Cost: {fromScratchMode ? '2 landing pages (2 credits)' : '1 landing page (1 credit)'}
        </Text>
      )}
    </View>
  );
};

export default LandingPageGeneration;